import script from "./NetworkChangeConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkChangeConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./NetworkChangeConfirmation.vue?vue&type=style&index=0&id=fd3c7302&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd3c7302"]])

export default __exports__